export default "/50f517735fec46580f19aae3e56e9fe21614ea75/c5d6534f4f2cb925009575e748220704.svg";